// @flow

import { observer } from "mobx-react";
import React from "react";
import AvatarEditor from 'react-avatar-editor'
import ImageHelper from "app/util/ImageHelper";
import AppearanceStore from "app/stores/AppearanceStore";

import "./EditAvatar.scss";

type Props = {
    image?: string
};

type State = {
    state: number,
    image: sring
};


@observer
export default class EditAvatar extends React.Component<Props, State> {
    containerRef: ?HTMLElement;

    constructor(props) {
        super(props);
        this.state = {
            scale: this.props.user.profile_image ? 1 : 1.2,
            image: this.props.user.profile_image ? ImageHelper.makeUrl(this.props.user.profile_image, "jpg") : null, //"https://me.rgou.net/storage/profile/7c7bc98fc0203810f89cea3b1852a6cd.jpg"
        };
        this.handleScale = this.handleScale.bind(this);
        this.handleNewImage = this.handleNewImage.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }    

    handleScale(e) {
        const scale = parseFloat(e.target.value)
        this.setState({ scale })
    }

    handleNewImage(e) {
        this.setState({ image: e.target.files[0] })
    }

    handleSubmit(e) {
        e.preventDefault();
        const canvas = this.editor.getImageScaledToCanvas()
        canvas.toBlob((blob) => {
            const data = new FormData()
            data.append("profile_image", blob, "filename.jpg");
            this.submit(data)
        }, "image/jpeg", 95);
    }

    submit(data) {
        fetch('/user', {
          method: 'POST',
          body: data
        }).then((test) => {
            console.log(test);
            window.location.reload(true);
        });
      }


    setEditorRef = editor => {
        if (editor) this.editor = editor
    }

    render() {
        return (
            <div className="EditAvatar row">
                <div className="col-md-5">
                    <AvatarEditor
                        ref={this.setEditorRef}
                        image={this.state.image}
                        width={150}
                        height={150}
                        border={50}
                        color={AppearanceStore.theme === 'dark' ? [0, 0, 0, 0.6] : [255, 255, 255, 0.7]} // RGBA
                        scale={parseFloat(this.state.scale)}
                        rotate={0}
                    />
                </div>
                <div className="col-md-7">
                    <div className="form-group">
                        <label htmlFor="first_name">Zoom <small>{ this.state.scale }</small></label>
                        <input
                            id="first_name"
                            name="scale"
                            type="range"
                            onChange={this.handleScale}
                            min="1"
                            max="4"
                            step="0.01"
                            defaultValue={this.state.scale}
                            disabled={null === this.state.image}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="new_image">Upload a new profile picture</label>
                        <input id="new_image"name="new_image" type="file" onChange={this.handleNewImage} className="form-control" accept=".png,.jpg,.gif" />
                    </div>
                    
                </div>

                <div className="col-md-12">
                    <footer className="row">
                        <div className="col-sm-3">
                            <button className="btn btn-primary" onClick={this.handleSubmit} disabled={!this.state.image}>
                                <i className="fa fa-check"></i> Update picture
                            </button>
                        </div>
                        { this.props.user.profile_image &&
                            <div className="col-sm-3">
                                <form action="/user" method="post">
                                    <button className="btn btn-default" type="submit" name="reset_profile_image" value="1">
                                        <i className="fa fa-check"></i> Reset picture
                                    </button>
                                </form>                
                            </div>
                        }
                    </footer>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/EditAvatar/EditAvatar.js